<template>
  <el-dialog :title="$t('64')" :close-on-click-modal="false" append-to-body :visible.sync="visible">
    <el-form class="demo-ruleForm">
      <h1 class="list-title">{{ $t('360') }}</h1>
      <el-form-item
        :label="item.key + '：'"
        v-for="(item, index) in list.detail && list.detail.detail ? list.detail.detail : []"
        :key="index"
      >
        <span v-if="item.type === 0">{{ item.value }}</span>
        <el-image
          style="width: 100px; height: 100px"
          v-else
          v-for="(p, i) in item.value"
          :src="p"
          :key="i"
          :preview-src-list="item.value"
        >
        </el-image>
        <template v-if="item.alert_msg">
          <p class="warn" v-for="(msg, msgindex) in item.alert_msg" :key="msgindex">{{ msg }}</p>
        </template>
      </el-form-item>
    </el-form>
    <h1 class="list-title">{{ $t('approval_process') }}</h1>
    <!-- 审批流 -->
    <ul class="process-his">
      <li v-for="(item, index) in stream" :key="index">
        <!-- isok 进行中 -->
        <i
          :style="{ color: getColor(item.state_code) }"
          :class="(item.is_ok === 1 ? 'flow-haveing' : '') + ' ' + (item.iconName || 'process-his-dot') + ' state-icon'"
        ></i>
        <div class="process-his-text-arr">
          <div>
            <span>
              {{ item.title }}
            </span>
          </div>
          <!-- 会签/或签  只在进行中的节点展示  -->
          <div
            v-if="item.node_audit_type && item.approval_info.approvalList && item.approval_info.approvalList.length > 1"
            class="flow-audit"
          >
            <p>{{ item.node_audit_type === 1 ? $t('1921') : $t('1920') }}</p>
          </div>
          <!-- 审批人 -->
          <div v-if="item.approval_info.empty_info" class="flow-audit">
            {{ item.approval_info.empty_info }}
          </div>
          <template v-if="item.approval_info.approvalList && item.approval_info.approvalList.length">
            <div
              v-for="(info, infoIndex) in item.approval_info.approvalList"
              :key="info.staff_id + '_' + infoIndex"
              class="process-his-info"
            >
              <template v-if="(workflowApproval[index] === 1 && infoIndex === 0) || workflowApproval[index] !== 1">
                <div class="process-his-text">
                  <p v-if="info.staff_name" class="process-his-text-name staff-name">{{ info.staff_name }}</p>
                  <span
                    v-if="workflowApproval[index] === 1 && infoIndex === 0"
                    class="more"
                    @click="handleOpen('workflowApproval', index, 2)"
                  >
                    <i :class="workflowApproval[index] === 1 ? '' : 'bottom'"></i>
                  </span>
                  <span
                    v-if="workflowApproval[index] === 2 && infoIndex === item.approval_info.approvalList.length - 1"
                    class="more"
                    @click="handleOpen('workflowApproval', index, 1)"
                  >
                    <i :class="workflowApproval[index] === 1 ? '' : 'bottom'"></i>
                  </span>
                </div>
                <!-- 已转交展示，已转交的数据只有一条 -->
                <div v-if="item.approval_info.delive_info" class="flow-audit">
                  {{ item.approval_info.delive_info }}
                </div>
                <p
                  v-if="info.state && item.is_ok !== 2"
                  class="staff-state"
                  :style="{ color: getColor(info.state_code) }"
                >
                  {{ info.state }}
                </p>
                <p v-if="info.remark" class="staff-name">{{ info.remark }}</p>
              </template>
            </div>
          </template>
          <!-- 抄送人 -->
          <div v-if="item.cc_info.title" class="flow-audit">
            {{ item.cc_info.title }}
          </div>
          <div v-if="item.cc_info.empty_info" class="flow-audit">
            {{ item.cc_info.empty_info }}
          </div>
          <div v-if="item.cc_info.ccList && item.cc_info.ccList.length" class="process-his-info process-cc-info">
            <div class="process-cc-text">
              <div ref="workflowCInfo" :data-num="index">
                <span
                  v-for="(info, infoIndex) in item.cc_info.ccList"
                  :key="info.staff_id + '_' + infoIndex"
                  class="process-his-text-name staff-name"
                >
                  {{ info.staff_name }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <p class="process-his-state">
          <span v-if="item.audit_at">
            {{ item.audit_at }}
          </span>
        </p>
      </li>
    </ul>
    <template slot="footer">
      <el-button type="primary" plain @click="visible = false">{{ $t('131') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { seeFn } from 'api/approval/search'
// import timeLine from '@/components/timeLine'
const iconType = new Map([
  [0, 'el-icon-circle-check'],
  [1, 'el-icon-more'],
  [2, '']
])

export default {
  // components: {
  //   timeLine
  // },
  data() {
    return {
      visible: false,
      workflowApproval: {},
      list: [],
      stream: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(item) {
      this.visible = true
      this.getData(item)
    },
    getColor(state) {
      return {
        0: '#2FC25B',
        1: '#FFA015', // 待审批 橙色
        2: '#2FC25B', // 已同意 绿色
        3: '#F85656', // 已驳回 红色
        4: '#909399', // 已撤销 灰色
        6: '#F85656', // 已拒绝撤销 红色
        7: '#2FC25B' // 已同意 绿色
      }[state || 0]
    },
    handleOpen(key, index, value) {
      this[key][index] = value
    },
    async getData(item) {
      if (!item || !item.audit_id) return false
      const res = await seeFn({
        audit_id: item.audit_id,
        audit_type: Number(item && item.type ? item.type : 0)
      })
      if (res && res.code === 1) this.list = res.data
      this.stream = [...res.data.stream, ...res.data.cancel_stream].map((v, index) => {
        v.iconName = iconType.get(v.is_ok) || ''
        v.staff_info_id_more = v.staff_info_id // .length > 2 ? v.staff_info_id.slice(2) : [];
        // 1收起， 2展开， -1 不展示按钮
        const value = v.approval_info.approvalList && v.approval_info.approvalList.length > 1 ? 1 : -1
        this.$set(this.workflowApproval, index, value)
        return v
      })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-form-item {
  margin-bottom: 2px;
}
.staff-list {
  line-height: 30px;
  color: rgb(92, 91, 90);
}
.list-title {
  margin-bottom: 10px;
}
.time-line {
  padding: 0px;
  border-top: 1px solid $borderColor;
  padding-top: 15px;
}
.line-content-wrap {
  display: flex;
  h1 {
    margin: 0;
    font-size: 14px;
  }
  p {
    line-height: 40px;
  }
  &-right {
    transform: translateY(-5px);
    text-align: right;
    flex: 1;
  }
}
.warn {
  color: #f59c26;
  transform: translateY(-10px);
  line-height: 25px;
}
.process-his {
  width: 100%;
  margin-bottom: 7px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
  padding: 10px 0;
  li {
    flex: 1;
    margin-left: 15px;
    border-left: 1px solid #e7e7e7;
    padding: 0 8px 26px 20px;
    box-sizing: border-box;
    position: relative;
    .process-his-info {
      margin-bottom: 10px;
      .process-his-text {
        margin-top: 10px;
        display: flex;
        align-items: center;
        .staff-name {
          margin-top: 0;
        }
      }
    }
    .more {
      height: 16px;
      width: 16px;
      display: inline-block;
      background: #f7f6f6;
      position: relative;
      cursor: pointer;
      i {
        width: 0;
        height: 0;
        position: absolute;
        top: 6px;
        left: 4px;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 6px solid #606266;
        &.bottom {
          transform: rotate(180deg);
          top: 5px;
          transition: 1s;
        }
      }
    }
    .state-icon {
      display: block;
      position: absolute;
      left: -8px;
      top: -1px;
      background: #fff;
      width: 18px;
      height: 18px;
      font-size: 16px;
    }
    .process-his-dot {
      &::before {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        background: #cac9c9;
        margin: auto;
        border-radius: 10px;
      }
    }
    .process-his-text-arr {
      flex: 1;
      .toggle-more {
        color: skyblue;
      }
      .staff-state {
        font-size: 12px;
        margin-top: 4px;
      }
      .flow-audit {
        opacity: 0.5;
        font-size: 12px;
        margin-top: 6px;
      }
      .staff-name {
        display: inline-block;
        padding: 4px 6px;
        border-radius: 4px;
        color: rgb(126, 126, 126);
        background: #f7f6f6;
        font-size: 14px;
        margin: 10px 10px 0 0;
        font-size: 12px;
        text-align: center;
      }
    }
    .process-his-state {
      position: absolute;
      right: 10px;
      top: 0;
      width: 140px;
      display: flex;
      flex-direction: column;
      text-align: right;
      color: #999;
      word-break: break-all;
    }
    .van-icon {
      position: absolute;
      top: -1px;
      left: -10px;
      font-size: 18px;
      z-index: 9;
      color: #999;
    }
    .flow-haveing {
      background: rgb(255, 160, 21);
      color: #fff !important;
      width: 14px;
      height: 15px;
      border-radius: 18px;
      font-size: 12px;
      text-align: center;
      padding: 1px 0 0 1px;
    }
    // .process-his-dot {
    //   @size: 9px;
    //   position: absolute;
    //   width: @size;
    //   height: @size;
    //   background-color: #e5e5e5;
    //   border-radius: 50%;
    //   left: -(@size / 2);
    // }
    &:last-child {
      border: 0;
      padding: 0 8px 8px 20px;
    }
  }
}
</style>
